import React, { useState, useEffect } from "react";
import {
  FaTimes,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaWhatsapp,
} from "react-icons/fa";
import { CgMenuRightAlt } from "react-icons/cg";
import "../Header/Header.css";
import { Link } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isTopBarVisible, setTopBarVisible] = useState(true);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setTopBarVisible(false); // Hide top bar on scroll down
      } else if (currentScrollY < lastScrollY || currentScrollY <= 50) {
        setTopBarVisible(true); // Show top bar on scroll up or at top
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className="full-header">
        <div
          className={`header ${isTopBarVisible ? "top-bar-visible" : "top-bar-hidden"}`}
        >
          {/* Top Bar */}
          {isTopBarVisible && (
            <div className="top-bar">
              <p className="top-text">Address:183 Noida ,India</p>
              <div className="top-last">
                <div>
                  <FaEnvelope /> info@example.com
                </div>
                <div>
                  <FaPhone /> Mob: +91 000000000
                </div>
              </div>
            </div>
          )}

          {/* Main Header */}
          <div className="main-header">
            <img src="/logo.webp" className="logo1" alt="logo" />

            {/* Navigation Links */}
            <nav className="nav-links">
              <Link to="/">Home</Link>

              <Link to="/aboutus">About Us</Link>

              <div className="dropdown">
                <a href="#services">Services</a>
                <div className="dropdown-menu">
                  <Link to="/services/1">Exploration and Surveying</Link>
                  <Link to="/services/2">Resource Extraction</Link>
                  <Link to="/services/3">Mining Safety & Risk Management</Link>
                  <Link to="/services/4">Environmental Management</Link>
                  <Link to="/services/5">Logistics and Transportation</Link>
                  <Link to="/services/6">
                    Consulting and Project Management
                  </Link>
                </div>
              </div>

              <Link to="/contactus">Contact</Link>
            </nav>
            <div className="last">
              {/* Book a Meeting Button */}
              <Link to="/contactus">
                <button className="book-meeting">CONNECT</button>
              </Link>

              {/* Hamburger Menu */}
            </div>
          </div>

          {/* Slider Menu */}
          {isMenuOpen && (
            <div className="menu-slider">
              <div className="menu-header">
                <button className="close-menu" onClick={toggleMenu}>
                  <FaTimes />
                </button>
              </div>
              <img src="logo.svg" className="logo" alt="logo" />
              <p>
                Welcome to IT Solutions, your trusted business solution
                provider.
              </p>
              <h4>Get in Touch</h4>
              <div className="contact-info">
                <div>
                  <FaEnvelope /> <span>Email: info@example.com</span>
                </div>
                <div>
                  <FaPhone /> <span>Phone: +91 000000000</span>
                </div>
                <div>
                  <FaMapMarkerAlt />{" "}
                  <span>Address: xyz noida,uttar Pradesh</span>
                </div>
              </div>
              <div className="social-icons">
                <a href="#">
                  <FaInstagram />
                </a>
                <a href="#">
                  <FaFacebookF />
                </a>
                <a href="#">
                  <FaLinkedinIn />
                </a>
                <a href="#">
                  <FaWhatsapp />
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Header;
